export default function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/descending.js
// module id = 1040
// module chunks = 0